import gql from 'graphql-tag';

export const GET_PAYMENTPLAN_SUMMARY = gql`
  query GetPaymentPlanSummary {
    guarantor {
      paymentPlans {
        paymentPlanId
        totalBalance
        monthlyBalanceDue
        paymentDueDate
      }
      checkPaymentPlansEligiblity {
        eligibleForPaymentPlans
        guarantorRelationship
      }
    }
  }
`;
